import React, { useState, useEffect } from "react";
import { Table, Modal, Button, Spin } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import BackRouteButton from "src/common/components/BackRouteButton";

import "./index.css";

export default ({ storehouse }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const showModal = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setSelectedRecord(null);
    setIsModalVisible(false);
  };

  const prepareDataSource = () => {
    const dataSource = [];

    storehouse.productsCategories.forEach((category) => {
      category.instances.forEach((instance) => {
        const row = {
          key: instance._id,
          title:
            instance.title.replace(/пшеничная|Хлебопекарная/g, "") +
            " " +
            instance.sizeOfPack +
            "kg",
          weight: instance.weight,
        };
        dataSource.push(row);
      });
    });
    return dataSource;
  };

  const columns = [
    {
      title: <span className="column-title-font">Name</span>,
      dataIndex: "title",
      key: "title",
      render: (text) => <span className="column-content-font">{text}</span>,
    },
    {
      title: <span className="column-title-font">Available</span>,
      dataIndex: "weight",
      key: "weight",
      render: (text, record) => (
        <span className="column-content-font">
          {record.weight.totalAvailable}kg
        </span>
      ),
    },
    {
      title: <span className="column-title-font">More Info</span>,
      dataIndex: "moreInfo",
      key: "moreInfo",
      render: (_, record) => (
        <>
          <Button
            type="link"
            onClick={() => showModal(record)}
            className="button--balance-modal"
          >
            <BarChartOutlined />
          </Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    if (!data) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (storehouse) {
      setData(prepareDataSource());
    }
  }, [storehouse]);

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">Product Balance</h4>
        <Table pagination={false} dataSource={data} columns={columns} />
        {selectedRecord && (
          <Modal
            title={
              <h3 className="common-modal-title">{selectedRecord.title}</h3>
            }
            open={isModalVisible}
            onCancel={handleCancel}
            footer={null}
          >
            <div className="custom-modal-content">
              <span className="column-content-font">
                Total available for sale: {selectedRecord.weight.totalAvailable}
                kg
              </span>
              <span className="column-content-font">
                Total in warehouse (available + reserved):{" "}
                {selectedRecord.weight.totalReserved +
                  selectedRecord.weight.totalAvailable}
                kg
              </span>
              <span className="column-content-font">
                Total reserved by customers:{" "}
                {selectedRecord.weight.totalReserved}kg
              </span>
              <span className="column-content-font">
                Total shipped but not paid: {selectedRecord.weight.totalShipped}
                kg
              </span>
              <span className="column-content-font">
                Total paid but not shipped: {selectedRecord.weight.totalPaid}kg
              </span>

              <h3 className="common-modal-title">Statistics</h3>
              <span className="column-content-font">
                Total produced: {selectedRecord.weight.totalProduced}kg
              </span>
              <span className="column-content-font">
                Total sold: {selectedRecord.weight.totalSold}kg
              </span>
              <span className="column-content-font">
                Total written off: {selectedRecord.weight.totalWriteOffs}kg
              </span>
              <span className="column-content-font">
                Total returns: {selectedRecord.weight.totalReturned}kg
              </span>
            </div>
          </Modal>
        )}
      </Spin>
    </div>
  );
};
